"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERMISSION_SUPERADMIN = 'superadmin';
exports.PERMISSION_EVERYONE = '$everyone';
exports.PERMISSION_AUTHENTICATED = '$authenticated';
exports.PERMISSION_UNAUTHENTICATED = '$unauthenticated';
exports.PERMISSION_READ_ALL = 'all.read';
exports.PERMISSION_READ_ALL_OF_CUSTOMER = 'allOfCustomer.read';
exports.PERMISSION_CREATE_USER = 'user.create';
exports.PERMISSION_UPDATE_USER = 'user.update';
exports.PERMISSION_DELETE_USER = 'user.delete';
exports.PERMISSION_READ_USER = 'user.read';
exports.PERMISSION_READ_ALL_USERS = 'allUsers.read';
exports.PERMISSION_READ_ALL_USERS_OF_CUSTOMER = 'allUsersOfCustomer.read';
exports.PERMISSION_UPDATE_BUDGET = 'user.udpateBudget';
exports.PERMISSION_DISABLE_USER = 'user.disable';
exports.PERMISSION_ENABLE_USER = 'user.enable';
exports.PERMISSION_ENABLE_VERIFIELD_EMAIL = 'user.enableVerifiedEmail';
exports.PERMISSION_CHECKBOX_BUDGET_USER = 'user.checkboxBudget';
exports.PERMISSION_CHECKBOX_UNLIMITED_USER = 'user.checkboxUnlimited';
exports.PERMISSION_EXPORT_USER = 'user.export';
exports.PERMISSION_CREATE_ROLE = 'role.create';
exports.PERMISSION_UPDATE_ROLE = 'role.update';
exports.PERMISSION_DELETE_ROLE = 'role.delete';
exports.PERMISSION_READ_ROLE = 'role.read';
exports.PERMISSION_CREATE_PROFILE = 'profile.create';
exports.PERMISSION_UPDATE_PROFILE = 'profile.update';
exports.PERMISSION_DELETE_PROFILE = 'profile.delete';
exports.PERMISSION_READ_PROFILE = 'profile.read';
exports.PERMISSION_READ_ALL_PROFILE = 'allProfile.read';
exports.PERMISSION_READ_ALL_PROFILE_OF_CUSTOMER = 'allProfileOfCustomer.read';
exports.PERMISSION_CREATE_BANNER = 'banner.create';
exports.PERMISSION_UPDATE_BANNER = 'banner.update';
exports.PERMISSION_DELETE_BANNER = 'banner.delete';
exports.PERMISSION_READ_BANNER = 'banner.read';
exports.PERMISSION_READ_ALL_BANNERS = 'allBanners.read';
exports.PERMISSION_READ_ALL_BANNERS_OF_CUSTOMER = 'allBannersOfCustomer.read';
exports.PERMISSION_READ_BANNER_TEMPLATE = 'bannerTemplate.read';
exports.PERMISSION_CREATE_BANNER_TEMPLATE = 'bannerTemplate.create';
exports.PERMISSION_UPDATE_BANNER_TEMPLATE = 'bannerTemplate.update';
exports.PERMISSION_DELETE_BANNER_TEMPLATE = 'bannerTemplate.delete';
exports.PERMISSION_READ_IMAGE = 'image.read';
exports.PERMISSION_CREATE_IMAGE = 'image.create';
exports.PERMISSION_UPDATE_IMAGE = 'image.update';
exports.PERMISSION_DELETE_IMAGE = 'image.delete';
exports.PERMISSION_CREATE_COMMON = 'common.create';
exports.PERMISSION_UPDATE_COMMON = 'common.update';
exports.PERMISSION_DELETE_COMMON = 'common.delete';
exports.PERMISSION_READ_COMMON = 'common.read';
exports.PERMISSION_CREATE_TAGS = 'tags.create';
exports.PERMISSION_UPDATE_TAGS = 'tags.update';
exports.PERMISSION_DELETE_TAGS = 'tags.delete';
exports.PERMISSION_READ_TAGS = 'tags.read';
exports.PERMISSION_CREATE_EQUIPMENT = 'equipment.create';
exports.PERMISSION_UPDATE_EQUIPMENT = 'equipment.update';
exports.PERMISSION_DELETE_EQUIPMENT = 'equipment.delete';
exports.PERMISSION_READ_EQUIPMENT = 'equipment.read';
exports.PERMISSION_READ_ALL_EQUIPMENTS = 'allEquipments.read';
exports.PERMISSION_CREATE_OWNER = 'owner.create';
exports.PERMISSION_READ_OWNER = 'owner.read';
exports.PERMISSION_UPDATE_OWNER = 'owner.update';
exports.PERMISSION_DELETE_OWNER = 'owner.delete';
exports.PERMISSION_READ_ALL_OWNER = 'allOwners.read';
exports.PERMISSION_READ_ALL_OWNER_OF_CUSTOMER = 'allOwnersOfCustomer.read';
exports.PERMISSION_ASSIGN_OWNER_CAMPAIGN = 'owner.assign.campaign';
exports.PERMISSION_ASSIGN_OWNER_LOCATION = 'owner.assign.location';
exports.PERMISSION_ASSIGN_OWNER_PROFILE = 'owner.assign.profile';
exports.PERMISSION_VIEW_OWNER_CAMPAIGN = 'owner.view.campaign';
exports.PERMISSION_VIEW_OWNER_LOCATION = 'owner.view.location';
exports.PERMISSION_VIEW_OWNER_PROFILE = 'owner.view.profile';
exports.PERMISSION_READ_ORDER = 'order.read';
exports.PERMISSION_CREATE_LOCATION = 'location.create';
exports.PERMISSION_READ_LOCATION = 'location.read';
exports.PERMISSION_UPDATE_LOCATION = 'location.update';
exports.PERMISSION_DELETE_LOCATION = 'location.delete';
exports.PERMISSION_READ_ALL_LOCATION = 'allLocations.read';
exports.PERMISSION_READ_ALL_LOCATION_OF_CUSTOMER = 'allLocationsOfCustomer.read';
exports.PERMISSION_EXPORT_LOCATION = 'location.export';
exports.PERMISSION_GEN_HTML = 'location.genHTML';
exports.PERMISSION_DISABLE_LOCATION = 'location.disable';
exports.PERMISSION_ENABLE_LOCATION = 'location.enable';
exports.PERMISSION_UPDATE_CAMPAIGN_PRIORITY = 'location.changePriority';
exports.PERMISSION_ADVANCE_LOCATION = 'location.advance';
exports.PERMISSION_CREATE_BASIC_LOCATION = 'basicLocation.create';
exports.PERMISSION_UPDATE_BASIC_LOCATION = 'basicLocation.update';
exports.PERMISSION_UPDATE_ADVANCE_LOCATION = 'advanceLocation.update';
exports.PERMISSION_CREATE_CAMPAIGN = 'campaign.create';
exports.PERMISSION_READ_CAMPAIGN = 'campaign.read';
exports.PERMISSION_UPDATE_CAMPAIGN = 'campaign.update';
exports.PERMISSION_DELETE_CAMPAIGN = 'campaign.delete';
exports.PERMISSION_CONFIG_CAMPAIGN = 'campaign.config';
exports.PERMISSION_ENABLE_CAMPAIGN = 'campaign.enable';
exports.PERMISSION_DISABLE_CAMPAIGN = 'campaign.disable';
exports.PERMISSION_INCOME_CAMPAIGN = 'campaign.income';
exports.PERMISSION_COPY_CAMPAIGN = 'campaign.copy';
exports.PERMISSION_READ_ALL_CAMPAIGN = 'allCampaigns.read';
exports.PERMISSION_READ_ALL_CAMPAIGN_OF_CUSTOMER = 'allCampaignsOfCustomer.read';
exports.PERMISSION_MUATATION_APPROVE_CAMPAIGN = 'approveCampaign';
exports.PERMISSION_MUATATION_DISABLE_CAMPAIGN = 'disableCampaign';
exports.PERMISSION_MUATATION_ENABLE_CAMPAIGN = 'enableCampaign';
exports.PERMISSION_MUATATION_SCHEDULE_CAMPAIGN = 'scheduleCampaign';
exports.PERMISSION_CREATE_BOOKING_CAMPAIGN_ONLINE = 'bookingCampaignOnline.create';
exports.PERMISSION_CREATE_USERGUIDE = 'userguide.create';
exports.PERMISSION_READ_USERGUIDE = 'userguide.read';
exports.PERMISSION_UPDATE_USERGUIDE = 'userguide.update';
exports.PERMISSION_DELETE_USERGUIDE = 'userguide.delete';
exports.PERMISSION_READ_ALL_USERGUIDE = 'allUserGuides.read';
exports.PERMISSION_CREATE_CAMPAIGN_MAPPING = 'campaignMapping.create';
exports.PERMISSION_READ_CAMPAIGN_MAPPING = 'campaignMapping.read';
exports.PERMISSION_UPDATE_CAMPAIGN_MAPPING = 'campaignMapping.update';
exports.PERMISSION_DELETE_CAMPAIGN_MAPPING = 'campaignMapping.delete';
exports.PERMISSION_READ_ALL_CAMPAIGN_MAPPING = 'allCampaignMappings.read';
exports.PERMISSION_READ_ALL_CAMPAIGN_MAPPING_OF_CUSTOMER = 'allCampaignMappingsOfCustomer.read';
exports.PERMISSION_CREATE_NOTIFICATION = 'notification.create';
exports.PERMISSION_DELETE_NOTIFICATION = 'notification.delete';
exports.PERMISSION_UPDATE_NOTIFICATION = 'notification.update';
exports.PERMISSION_READ_NOTIFICATION = 'notification.read';
exports.PERMISSION_READ_ALL_NOTIFICATION = 'allNotifications.read';
exports.PERMISSION_READ_ALL_NOTIFICATION_OF_CUSTOMER = 'allNotificationsOfCustomer.read';
exports.PERMISSION_CREATE_MESSAGE = 'message.create';
exports.PERMISSION_UPDATE_MESSAGE = 'message.update';
exports.PERMISSION_DELETE_MESSAGE = 'message.delete';
exports.PERMISSION_READ_MESSAGE = 'message.read';
exports.PERMISSION_READ_ALL_MESSAGE = 'allMessages.read';
exports.PERMISSION_READ_ALL_MESSAGE_OF_CUSTOMER = 'allMessagesOfCustomer.read';
exports.PERMISSION_CONFIG_REVENUE = 'revenue.config';
exports.PERMISSION_READ_PLAN = 'plan.read';
exports.PERMISSION_READ_ALL_PLAN = 'allPlans.read';
exports.PERMISSION_CREATE_PLAN = 'plan.create';
exports.PERMISSION_UPDATE_PLAN = 'plan.update';
exports.PERMISSION_DELETE_PLAN = 'plan.delete';
exports.PERMISSION_DELETE_TFA = 'tfa.delete';
exports.PERMISSION_READ_TFA = 'tfa.read';
exports.PERMISSION_QUERY_TRAFFIC_TODAY = 'countTrafficToday';
exports.PERMISSION_QUERY_COUNT_THIS_MONTH = 'countThisMonth';
exports.PERMISSION_QUERY_AVAILABLE_BOOKING = 'availableBooking';
exports.PERMISSION_QUERY_BOOKING_DATA = 'bookingData';
exports.PERMISSION_QUERY_TOTAL_DEVICE = 'totalDevice';
exports.PERMISSION_QUERY_REPORT_LOGIN = 'reportLogin';
exports.PERMISSION_QUERY_REPORT_TRACKING = 'reportTracking';
exports.PERMISSION_QUERY_DEVICE_DATA_BY_LOCATION = 'deviceDataByLocation';
exports.PERMISSION_QUERY_LOCATION_STATS = 'locationStats';
exports.PERMISSION_QUERY_OS_AND_DEVICE_TYPE = 'osAndDeviceType';
exports.PERMISSION_QUERY_REPORT_LOCATION = 'reportLocation';
exports.PERMISSION_QUERY_LOCATION_CLICK_3_MONTH = 'locationClick3Month';
exports.PERMISSION_QUERY_TRACKING_DATA_3_MONTH = 'trackingData3Month';
exports.PERMISSION_QUERY_TRACKING_LOCATION = 'trackingLocation';
exports.PERMISSION_QUERY_SURVEY_DATA = 'surveyData';
exports.PERMISSION_QUERY_OS_DATA = 'osData';
exports.PERMISSION_QUERY_DEVICE_DATA = 'deviceData';
exports.PERMISSION_QUERY_REPORT_VISIT = 'reportVisit';
exports.PERMISSION_CREATE_BALANCEHISTORY = 'balanceHistory.create';
exports.PERMISSION_UPDATE_BALANCEHISTORY = 'balanceHistory.update';
exports.PERMISSION_DELETE_BALANCEHISTORY = 'balanceHistory.delete';
exports.PERMISSION_MENU_DASHBOARD = 'dashboard.';
exports.PERMISSION_MENU_CAMPAIGN_BOOKING = 'campaign.booking';
exports.PERMISSION_MENU_CAMPAIGN_CAMPAIGNS = 'campaign.campaigns';
exports.PERMISSION_MENU_CAMPAIGN_CONFIG = 'campaign.config';
exports.PERMISSION_MENU_CAMPAIGN_KPI_MANAGEMENT = 'campaign.kpiManagement';
exports.PERMISSION_MENU_BOOKING_ONLINE = 'campaign.bookingOnline';
exports.PERMISSION_MENU_ACTIVE_CAMPAIGN = 'campaign.activeCampaign';
exports.PERMISSION_MENU_LOCATION = 'location';
exports.PERMISSION_MENU_LOCATION_EQUIPMENT = 'location.equipment';
exports.PERMISSION_MENU_LOCATION_PRIORITY = 'location.priority';
exports.PERMISSION_MENU_CAMPAIGN_PRIORITY = 'campaign.priority';
exports.PERMISSION_MENU_REVENUE_CAMPAIGNS = 'revenue.campaigns';
exports.PERMISSION_MENU_REVENUE_CONFIG = 'revenue.config';
exports.PERMISSION_MENU_REPORT_CAMPAIGN = 'report.campaigns';
exports.PERMISSION_MENU_REPORT_LOCATIONS = 'report.locations';
exports.PERMISSION_MENU_STATISTIC_INVENTORY = 'statistic.inventory';
exports.PERMISSION_MENU_BANNER = 'banner';
exports.PERMISSION_MENU_SETTING_IMAGE = 'setting.image';
exports.PERMISSION_MENU_SETTING_BANNER_TEMPLATE = 'setting.bannerTemplate';
exports.PERMISSION_MENU_SETTING_MODEL_DEVICE = 'setting.modelDevice';
exports.PERMISSION_MENU_SETTING_BRAND_AP = 'setting.brandAP';
exports.PERMISSION_MENU_SETTING_BRAND_CAMPAIGN = 'setting.brandCSampaign';
exports.PERMISSION_MENU_SETTING_GROUP_CATEGOGY = 'setting.groupGategory';
exports.PERMISSION_MENU_SETTING_INSTRUCTION = 'setting.instruction';
exports.PERMISSION_MENU_SETTING_COMMON = 'setting.common';
exports.PERMISSION_MENU_SETTING_DEVICE_GROUP = 'setting.deviceGroup';
exports.PERMISSION_MENU_SETTING_PLAN_LOCATION = 'setting.plan';
exports.PERMISSION_MENU_SETTING_LOCATION_CATEGORY = 'setting.location.category';
exports.PERMISSION_MENU_SETTING_TAGS = 'setting.tags';
exports.PERMISSION_MENU_SETTING_REGION = 'setting.region';
exports.PERMISSION_MENU_ORDER_HISTORY = 'order.history';
exports.PERMISSION_MENU_ORDER_DETAIL = 'order.detail';
exports.PERMISSION_MENU_ORDER_RESULT = 'order.result';
exports.PERMISSION_MENU_USER = 'user.users';
exports.PERMISSION_MENU_USER_ACCOUNT_SETTING = 'user.account.setting';
exports.PERMISSION_MENU_USER_PROFILE = 'user.profiles';
exports.PERMISSION_MENU_ASSIGN_CAMPAIGN = 'assign.campaign';
exports.PERMISSION_MENU_ASSIGN_LOCATION = 'assign.location';
exports.PERMISSION_MENU_ASSIGN_PROFILE = 'assign.profile';
exports.PERMISSION_MENU_USER_MANUAL_CREATE_GUIDE = 'userManual.create-guide';
exports.PERMISSION_MENU_USER_MANUAL = 'userManual.help-center';
exports.PERMISSION_MENU_NOTIFICATION = 'notification';
exports.PERMISSION_MENU_ALL = 'menu.all';
exports.PERMISSION_UPDATE_SALE_INFO_LOCATION = 'location.update-sale';
exports.VIEW_LOCATION_STATISTIC = 'dashboard.locationStatistic';
exports.VIEW_LOCATION_TRAFFIC = 'dashboard.locationTraffic';
exports.VIEW_LOCATION_SESSION_LOGIN = 'dashboard.locationSession';
exports.VIEW_CAMPAIGN_STATISTIC = 'dashboard.campaignStatistic';
exports.VIEW_AUDIENCE_STATISTIC = 'dashboard.audienceStatistic';
exports.PERMISSION_READ_CUSTOMER_TYPE = 'customerType.read';
exports.PERMISSION_CREATE_CUSTOMER_TYPE = 'customerType.create';
exports.PERMISSION_UPDATE_CUSTOMER_TYPE = 'customerType.update';
exports.PERMISSION_DELETE_CUSTOMER_TYPE = 'customerType.delete';
//# sourceMappingURL=roles-old.js.map